import React, { useEffect } from "react";
import { Heading } from "../../design/heading";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "../../design/table";
import { useCustodyOrder } from "../../contexts/CustodyOrderContext";
import CustodyOrderListItem from "./components/CustodyOrderListItem";
import EmptyStateView from "../../components/EmptyStateView";
import LoadingView from "../../components/LoadingView";
import ErrorView from "../../components/ErrorView";
import { useCreateCustodyOrderDialog } from "../../providers/CreateCustodyOrderDialogProvider/CreateCustodyOrderDialogProvider";
import { Button } from "../../design/button";
import { PlusIcon } from "@heroicons/react/20/solid";

const CustodyOrderListPage: React.FC = () => {
  const { openDialog } = useCreateCustodyOrderDialog();
  const { custodyOrders, loading, error } = useCustodyOrder();

  if (loading.list) {
    return <LoadingView title="Loading Custody Orders" />;
  }

  if (error.list) {
    return <ErrorView error={error.list} />;
  }

  return (
    <div className="space-y-4">
      <div className="flex items-end justify-between gap-4">
        <Heading>Custody Orders</Heading>
        <div className="flex items-center gap-2">
          <Button onClick={() => openDialog()}>
            <PlusIcon className="w-4 h-4" />
            <span className="hidden sm:block">Create Custody Order</span>
          </Button>
        </div>
      </div>
      {custodyOrders.length === 0 && (
        <EmptyStateView
          title="No Custody Orders"
          message="No Custody Orders found. Create a Custody Order to get started."
          action={
            <Button onClick={() => openDialog()}>
              <PlusIcon className="w-4 h-4" />
              <span className="hidden sm:block">Create Custody Order</span>
            </Button>
          }
        />
      )}
      {custodyOrders.length > 0 && (
        <Table>
          <TableHead>
            <TableRow>
              <TableHeader>Title</TableHeader>
              <TableHeader>Type</TableHeader>
              <TableHeader>Order Date</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {custodyOrders.map((custodyOrder) => {
              return (
                <CustodyOrderListItem
                  key={custodyOrder._id}
                  custodyOrder={custodyOrder}
                />
              );
            })}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default CustodyOrderListPage;
